import { useEffect, useState } from "react";
import { HiDotsVertical, HiOutlinePencil, HiOutlineTrash } from "react-icons/hi";
import ColorsCircles from "./colors-roles";
import { useSkillsAction } from "../../../../services/actions/skills.action";
import { useRecoilValue } from "recoil";
import { skillsAtom } from "../../../../services/atoms/skills.atom";
import toast, { Toaster } from "react-hot-toast";
import { includes } from "lodash";
import EditSkillModal from "./edit-competence-modal";
import CreateSkillsModal from "./create-competencia-modal";
import { AiOutlineClose } from "react-icons/ai";
import { InputIcon } from "../../../../components/inputs/input-icon";
import { HiMagnifyingGlass } from "react-icons/hi2";
import { ButtonIcon } from "../../../../components/buttons/button-icon";
import TableComponent from "../../../../components/table/table-component";
import { userAtom } from "../../../../services/atoms/auth.atoms";

const options = [
  {
    id: "opt-1",
    title: "Editar Competencia",
    action: "edit",
    icon: HiOutlinePencil, 
  },
  {
    id: "opt-2",
    title: "Eliminar Competencia",
    action: "remove",
    icon: HiOutlineTrash,
  },
];

const actions = [{ icon: HiDotsVertical, dropdown: true }]; 

const columns = [
 {
    Header: "Competencia",
    accessor: ({ name }) => <div>{name}</div>,
  },
  {
    Header: "Color(es)",
    accessor: ({ colorType }) => (
      <div style={{ display: "flex", flexDirection: "row" }}>
        {colorType.map((colors) => (
          <div style={{ minWidth: "25px" }}>
            <ColorsCircles colors={colors} />
          </div>
        ))}
      </div>
    ),
  },
  {
    Header: "Descripción",
    accessor: ({ description }) => (
      <div
        style={{
          width: "100%",
          overflowWrap: "break-word",
          alignContent: "start",
        }}
      >
        <span style={{ alignText: "start" }}>{description}</span>
      </div>
    ),
  },
  {
    Header: "Acciones",
    accessor: "",
    disableFilters: true,
    disableSortBy: true,
    type: "actions",
  },
];

const columnsAdmin = [
  {
     Header: "Competencia",
     accessor: ({ name }) => <div>{name}</div>,
   },
   {
     Header: "Color(es)",
     accessor: ({ colorType }) => (
       <div style={{ display: "flex", flexDirection: "row" }}>
         {colorType.map((colors) => (
           <div style={{ minWidth: "25px" }}>
             <ColorsCircles colors={colors} />
           </div>
         ))}
       </div>
     ),
   },
   {
     Header: "Descripción",
     accessor: ({ description }) => (
       <div
         style={{
           width: "100%",
           overflowWrap: "break-word",
           alignContent: "start",
         }}
       >
         <span style={{ alignText: "start" }}>{description}</span>
       </div>
     ),
   }
 ];

const initialSetOpenState = {
  create: false,
  edit: false,
};

const initialSkillsData = {
  id: "",
  name: "",
  description: "",
  colorType: [],
};

const initialSearchValue = { name: "", colorType: [] };

const Skills = (props) => {
  const { paginateSkills, deleteSkill } = useSkillsAction(); 
  const skills = useRecoilValue(skillsAtom); 
  const user = useRecoilValue(userAtom)
  const [open, setOpen] = useState(initialSetOpenState);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [skill, setSkill] = useState(initialSkillsData);
  const [searchExists, setSearch] = useState("");
  const [searchValues, setSearchValue] = useState(initialSearchValue);

  const handleChangePage = (e) => setPage(e + 1);

  const handleSetLimit = (e) => setLimit(e);

  const handleOpenModal = (key) =>
    setOpen((modal) => ({ ...modal, [key]: !modal[key] }));
  
  const handleChangeValue = (key, value) =>
    setSearchValue((prevValues) => ({ ...prevValues, [key]: value }));

  const handleOptionAction = (action, row) => {
    if (action === "edit") {
      setSkill(row);
      setOpen((modal) => ({ ...modal, edit: true }));
    }
    if (action === "remove") {
      setSkill(row);
      handleDeleteSkill(row, "esta competencia");
    }
  };

  const handleSearchByName = (e, key) => {
    e.preventDefault();
    const data = new FormData(e.target);
    let form = Object.fromEntries(data.entries());
    let search = { column: "competences.name", value: form["search"] };
    setSearch(form["search"]);
    paginateSkills({ page, limit, search });
  };

  const handleChangeColor = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue !== "false") {
      const color = event.target.value;
      let search = { column: "competences.colorType", value: color };
      setSearch(selectedValue);
      paginateSkills({ page, limit, search: search });
    } else {
      return;
    }
  };

  const handleCleanSearch = () => {
    setSearch("");
    setSearchValue(initialSearchValue);
    paginateSkills({ page, limit });
    resetSelect();
  };

  const resetSelect = () => {
    const select = document.querySelector('select[name="origen"]');
    select.selectedIndex = 0;
  };

  const handleConfirm = (toastId, row) => {
    deleteSkill(row.id, (res) => {
      if (includes(res?.message, "Request failed with status")) { 
        toast.error("La competencia no se ha podido eliminar", {
          duration: 4000,
        });
        toast.dismiss(toastId);
      } else {
        toast.success("Competencia eliminada exitosamente", { duration: 4000 });
        toast.dismiss(toastId);
        paginateSkills({ page, limit });
      }
    });
  };
  const handleCancel = (toastId) => {
    toast.dismiss(toastId);
  };

  const handleDeleteSkill = (row, text) => {
    toast(
      (t) => (
        <div className="gm-modal-form-group">
          <p style={{ color: "#003849" }}>
            ¿Estás seguro de que quieres eliminar {text}?
          </p>
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <button
              className="gm-secondary-button"
              onClick={() => handleCancel(t.id)}
            >
              Cancelar
            </button>
            <button
              className="gm-primary-button"
              onClick={() => handleConfirm(t.id, row)}
            >
              Confirmar
            </button>
          </div>
        </div>
      ),
      { duration: 6000 }
    );
  };

  useEffect(() => {
    paginateSkills({ page, limit });
    //eslint-disable-next-line
  }, [page, limit]);


  return (
    <div className="gm-configurations-screen-container">
      <Toaster />
      {open.edit && (
        <EditSkillModal
          open={open.edit}
          toggle={() => handleOpenModal("edit")}
          update={() => paginateSkills({ page, limit })}
          setSkill={setSkill}
          skill={skill}
        />
      )}
      {open.create && (
        <CreateSkillsModal
          open={open.create}
          toggle={() => handleOpenModal("create")}
          update={() => paginateSkills({ page, limit })}
        />
      )}

      <div>
        <div className="gm-ts-searchbar-container">
          <div className="gm-ts-searchbar-title-container">
            <form onSubmit={(e) => handleSearchByName(e, "name")}>
              <InputIcon
                Icon={HiMagnifyingGlass}
                type="text"
                placeholder="Buscar por nombre"
                name="search"
                value={searchValues.name}
                onChange={(e) => handleChangeValue("name", e.target.value)}
              />
            </form>
            <form>
              <div className="gm-input-icon-container">
                <select
                  name="origen"
                  onChange={(event) => {
                    handleChangeColor(event);
                  }}
                >
                  <option value={false}>Filtrar por Color</option>
                  <option value="azul">Estructurado / Azul</option>
                  <option value="rojo">Dominante / Rojo</option>
                  <option value="amarillo">Influyente / Amarillo</option>
                  <option value="verde">Sostenedor/ Verde</option>
                </select>
              </div>
            </form>
            {searchExists && (
              <button
                className="gm-clean-search-button"
                onClick={handleCleanSearch}
                type="button"
              >
                <AiOutlineClose size={18} />
              </button>
            )}
          </div>
          <div className="gm-ts-searchbar-actions-container">
            {user?.data.isSuperAdmin && (
              <ButtonIcon
                buttonLabel="Crear Competencia"
                type="button"
                className="gm-primary-button"
                onClick={() => handleOpenModal("create")}
              />
            )}
          </div>
        </div>
      </div>

      <div style={{ height: "50px" }}> </div>
      <TableComponent
        classNameBody="qs-table-body-params"
        data={skills?.payload || []}
        loading={skills.loading}
        emptyListInformer="small"
        columns={ user?.data?.isSuperAdmin ? columns : columnsAdmin}
        handleOptionAction={handleOptionAction}
        handleChangePage={handleChangePage}
        handleSetLimit={handleSetLimit}
        controlledPageCount={
          skills?.total ? Math.ceil(skills.total / limit) : 1
        }
        actions={actions}
        options={options}
        section={{ plural: "competencias", singular: "competencia" }}
        checkbox={false}
        manualPagination={true}
        pagination
      />
    </div>
  );
};

export default Skills;
